import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { 
    trainerNavigation,
    gymNavigation
} from 'app/mock-api/common/navigation/data';
import { AccountModeService, AccountMode } from 'app/core/user/account-mode.service';
import { take, switchMap, of } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi
{
    constructor(
        private _fuseMockApiService: FuseMockApiService,
        private _accountModeService: AccountModeService
    )
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {
                // Get navigation based on current account mode
                return this._accountModeService.currentMode$.pipe(
                    take(1),
                    switchMap((mode: AccountMode) => {
                        const navigation = mode === 'gym' 
                            ? cloneDeep(gymNavigation)
                            : cloneDeep(trainerNavigation);

                        return of([
                            200,
                            {
                                compact   : cloneDeep(navigation),
                                default   : cloneDeep(navigation),
                                futuristic: cloneDeep(navigation),
                                horizontal: cloneDeep(navigation)
                            }
                        ]);
                    })
                );
            });
    }
}
